import { render, staticRenderFns } from "./ObligCard.vue?vue&type=template&id=5c714c38&scoped=true&"
import script from "./ObligCard.vue?vue&type=script&lang=js&"
export * from "./ObligCard.vue?vue&type=script&lang=js&"
import style0 from "./ObligCard.vue?vue&type=style&index=0&id=5c714c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c714c38",
  null
  
)

export default component.exports